<div
  data-test-id="menu-wrapper"
  class="menu absolute right-0 top-[35px] rounded-lg bg-white overflow-y-auto max-h-[0px] z-100"
  [ngClass]="{ 'max-h-[220px]': opened }">
  <ul data-test-id="menu-list" class="flex flex-col w-full h-full pl-0 mb-0">
    <li
      *ngFor="let option of options"
      data-test-id="menu-list-item"
      class="flex items-center py-[10px] px-[15px] cursor-pointer hover:bg-gray-100"
      (click)="onSelect(option)"
      HasPermission
      [expectedPermission]="option.permissions">
      <span
        data-test-id="menu-list-item-label"
        class="text-xl whitespace-nowrap"
        [ngClass]="{ 'text-gray-600': !!!option.color, 'text-bey-red': option.color === 'red' }"
        >{{ option.label }}</span
      >
    </li>
  </ul>
</div>
